import Growth from "@/assets/icons/Growth.svg";
import { useState } from "react";
import Smile from "@/assets/icons/RedditCardSmile.svg";
import Modal from "@/components/ui/Modal";
import MarketScriptDetailsModal from "./MarketScriptDetailsModal";
import { EvidenceItem } from "./EvidenceCommentsDisplay";

export type TMarketScriptCard = {
  title: string;
  engagement_metric?: number;
  hook?: string;
  body?: string[];
  cta?: string;
  main_content: string;
  visual_cues: string[];
  voiceover_script: string;
  call_to_action: string;
  target_tags: {
    hierarchy: string;
    storyline: string;
    hook: string;
    cta: string;
    actor: string;
  };
  evidence_comments: EvidenceItem[];
  pain_points_addressed: string[];
  desires_fulfilled: string[];
  habits_leveraged: string[];
};

type TMarketScriptCardProps = {
  data: TMarketScriptCard;
  index: number;
};

const MarketScriptCard = ({ data, index }: TMarketScriptCardProps) => {
  const [isSelected, setIsSelected] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const truncateText = (text: string, maxLength: number = 100) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  return (
    <>
      <div
        className={`structure-card-shadow py-4 px-5 rounded-[20px] h-[530px] max-w-[444px] transition-all duration-200 flex flex-col ${
          isSelected ? "ring-2 ring-blue-500 bg-blue-50" : ""
        }`}
      >
        {/* Card Header */}
        <div className="flex-shrink-0">
          <h6 className="text-[#0D0D0D] font-semibold text-xl leading-6 tracking-normal mb-5">
            Recommendation {index}
          </h6>

          <h6 className="text-[#0D0D0D] font-semibold text-lg leading-6 tracking-normal mb-3 line-clamp-2">
            {data.title}
          </h6>

          <div className="flex gap-x-5 items-center mb-2">
            <div className="flex items-center gap-x-1 border border-[#9D9D9D] px-[4.5px] py-[3px] rounded-lg">
              <p className="text-[#A7A7A7] font-medium text-[13px] leading-[125%] tracking-[-0.75%]">
                Script Sourced from{" "}
                <span className="text-[#000000]">Reddit</span>
              </p>
              <Smile />
            </div>
            {data.engagement_metric && (
              <div className="bg-[#E2FFE3] rounded-[10px] py-1.5 px-2 inline-flex items-center text-xs font-medium">
                <Growth />
                <span className="text-[#0B8000] text-[13px] leading-[125%] tracking-[-0.75%] font-semibold">
                  {Math.round(data.engagement_metric)}% engagement
                </span>
              </div>
            )}
          </div>
          <p className="text-[#A7A7A7] text-sm leading-6 tracking-[0%] font-medium">
            Duration - <span className="text-[#212121]">30 sec</span>
          </p>
        </div>

        {/* Script Type Selector */}

        {/* Content Preview */}
        <div className="flex-1 flex flex-col min-h-0">
          <div className="bg-[#FDFDFD] border border-[#DDDDDD] py-3 px-[18px] rounded-lg flex-1 overflow-hidden">
            <div className="h-full flex flex-col">
              <div className="flex-1 overflow-y-auto">
                <div>
                  <p className="text-[#6D6D6D] text-sm leading-6 tracking-[0%] font-medium mb-2">
                    <span className="font-semibold">Visuals:</span>
                  </p>
                  <p className="text-[#6D6D6D] text-sm leading-6 tracking-[0%] font-medium whitespace-pre-line">
                    {truncateText(data.main_content, 510)}
                  </p>
                  {/* <p className="text-[#6D6D6D] text-sm leading-6 tracking-[0%] font-semibold mt-3 mb-1">
                    Visual Cues:
                  </p>
                  <ul className="list-disc ml-4 space-y-1">
                    {data.visual_cues.slice(0, 4).map((cue, index) => (
                      <li
                        key={index}
                        className="text-[#6D6D6D] text-sm leading-6 tracking-[0%] font-medium"
                      >
                        {truncateText(cue, 50)}
                      </li>
                    ))}
                    {data.visual_cues.length > 5 && (
                      <li className="text-[#6D6D6D] text-sm leading-6 tracking-[0%] font-medium">
                        +{data.visual_cues.length - 5} more...
                      </li>
                    )}
                  </ul> */}
                </div>
              </div>

              {/* Read More Button */}
              <div className="mt-3 pt-2 border-t border-[#EEEEEE]">
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors duration-200"
                >
                  Read More →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal isOpen={isModalOpen} setOpen={setIsModalOpen} width="900px">
        <MarketScriptDetailsModal data={data} />
      </Modal>
    </>
  );
};

export default MarketScriptCard;
